import { Link } from 'react-router-dom';
import learnylib from '../../img/logo.svg';
import biotech from '../../img/biotech.png';
import sonrava from '../../img/sonrava.png';
import vyv from '../../img/vyv.png';
import { useContext } from 'react';
import UserContext from '../../services/Context/UserContext';
import { Box } from '@mui/material';

const defaultLogo = {
    img: learnylib,
    w: 220,
    h: 58,
    sx: {}
};

const logos = [
    {
        siret: '79500130400018',
        img: biotech,
        w: 220,
        h: 93,
        style: {margin: '0px 10px'}
    },
    {
        siret: '12016762456000',
        img: sonrava,
        w: 220,
        h: 59.5,
        style: {margin: '10px'}
    },
    {
        siret: '53266183200032',
        img: vyv,
        w: 220,
        h: 50,
        style: {}
    }
];

export default function Logo({size, style}){

    const {user} = useContext(UserContext)

    const logo = logos.find(l => l.siret === user?.siret?.toString()) || defaultLogo;

    let width = size || logo.w;
    let height = Math.round(width * logo.h / logo.w)

    return <Link to="/">
        <Box>
            <img 
                src={logo.img} 
                alt='Logo' 
                width={width} 
                height={height}
                style={logo.style}
            />
        </Box>
    </Link> 
}